"use strict";
// packages/contracts/src/busca.ts — Fase 17.8, Plano 14 (D-18; T-17.8-14-02, T-17.8-14-04).
// Contrato de GET /api/v1/busca?q= (paleta Ctrl+K): quatro grupos de registros, cada um presente SÓ quando a sessão tem a
// permissão de leitura do dado. SOMENTE tipos e a constante do limite: nenhum campo monetário, nenhum dado além de
// título, apoio e o caminho interno do registro.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIMITE_POR_GRUPO_BUSCA = void 0;
/** Máximo de itens por grupo (UI-SPEC U-13). */
exports.LIMITE_POR_GRUPO_BUSCA = 5;
//# sourceMappingURL=busca.js.map